import React from 'react';
import Homeownership from './Homeownership';
import { content } from '../content';
import './BaseSection.css';

const BaseSection: React.FC = () => {
  return (
    <Homeownership 
      headline={content.homeownership.headline}
      description={content.homeownership.description}
      benefits={content.homeownership.benefits}
      cta={content.homeownership.cta}
      contactCta={content.homeownership.contactCta}
    />
  );
};

export default BaseSection;
